module.exports = __webpack_public_path__ + "static/media/thank-you_replace.c6c2ac71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thank-you_replace.svg
// module id = 1079
// module chunks = 21